import React, { useEffect, useState } from "react";
import { Container, Row, Col, Table, Button } from "react-bootstrap";
import { useParams, useNavigate, Link } from "react-router-dom";
import { BiRupee } from "react-icons/bi";
import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
import "./CustomerList.css";
import axios from "axios";

/* Helper to parse date formats used in your app */
const parsePossibleDate = (value) => {
  if (!value) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return new Date(value);
  const parts = value.split("/");
  if (parts.length === 3) {
    const d = parseInt(parts[0], 10);
    const m = parseInt(parts[1], 10) - 1;
    const y = parseInt(parts[2], 10);
    const dt = new Date(y, m, d);
    return isNaN(dt) ? null : dt;
  }
  const dt = new Date(value);
  return isNaN(dt) ? null : dt;
};

/* Calculation logic for aided salary (same as your SalaryAided component) */
// const calculateSalary = (item) => {
//   const gross =
//     (item.basic || 0) +
//     (item.sp || 0) +
//     (item.wa || 0) +
//     (item.da || 0) +
//     (item.hra || 0) +
//     (item.ma || 0);

//   const deduction =
//     (item.tpf || 0) +
//     (item.tpfd || 0) +
//     (item.cpsr || 0) +
//     (item.cpsa1 || 0) +
//     (item.gis || 0) +
//     (item.nhis || 0) +
//     (item.faCoop || 0) +
//     (item.ptItSr || 0);

//   const netSalary = gross - deduction;

//   return { gross, deduction, netSalary };
// };

/* Read aided salary records from localStorage or fallback demo data */
// const readAidedRecords = () => {
//   try {
//     const raw = localStorage.getItem("salary_aided_records_v1");
//     if (raw) return JSON.parse(raw);
//   } catch (e) {}
//   return [
//     {
//       user_id: 1,
//       name: "Maha",
//       doj: "2021-02-17",
//       basic: 25000,
//       sp: 2000,
//       wa: 1500,
//       da: 5000,
//       hra: 3200,
//       ma: 300,
//       tpf: 1000,
//       tpfd: 500,
//       cpsr: 800,
//       cpsa1: 600,
//       gis: 110,
//       nhis: 300,
//       faCoop: 200,
//       ptItSr: 150,
//     },
//     {
//       user_id: 2,
//       name: "Ravi",
//       doj: "17/02/2020",
//       basic: 22000,
//       sp: 1500,
//       wa: 1200,
//       da: 4000,
//       hra: 2800,
//       ma: 250,
//       tpf: 900,
//       tpfd: 450,
//       cpsr: 700,
//       cpsa1: 500,
//       gis: 100,
//       nhis: 250,
//       faCoop: 180,
//       ptItSr: 120,
//     },
//   ];
// };

const SalaryAidedDetail = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [salaryList, setSalaryList] = useState([]);
  const { user_id } = useParams();
  const navigate = useNavigate();
  const userId = Number(user_id);

  const [records, setRecords] = useState([]);
  const [record, setRecord] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // useEffect(() => {
  //   const data = readAidedRecords();
  //   setRecords(data);
  //   const found = data.find((r) => Number(r.user_id) === recordId) || null;
  //   setRecord(found);
  // }, [recordId]);
  useEffect(() => {
    axios.post(`${API_BASE_URL}salary_user_aided_list.php`, { user_id: userId })
      .then((response) => {
        if (response.data.head.code === 200) {

          const list = response.data.body;

          setSalaryList(list);
          setRecords(list);

          console.log("test", list);  // now NOT empty

          const found = list.find(r => Number(r.user_id) === userId) || null;
          setRecord(found);
          setIsLoading(false);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setSalaryList([]);
          setRecords([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setSalaryList([]);
        setRecords([]);
        setIsLoading(false);
      });
  }, [userId]);



  const handleDelete = (deleteId) => {
    if (!window.confirm("Delete this aided salary record?")) return;
    const updated = records.filter((r) => Number(r.user_id) !== Number(deleteId));
    setRecords(updated);
    localStorage.setItem("salary_aided_records_v1", JSON.stringify(updated));
    navigate("/salaryaided");
  };

  // if (!record) {
  //   return (
  //     <Container fluid className="my-4 outer-container">
  //       <h3 className="text-center">Aided Salary Detail</h3>
  //       <div className="text-center my-4">
  //         <p>No aided salary record found for id {userId}.</p>
  //         <Button variant="secondary" onClick={() => navigate("/salaryaided")}>
  //           Back to Aided Salary List
  //         </Button>
  //       </div>
  //     </Container>
  //   );
  // }

  // const calc = calculateSalary(record);

  return (
    <Container fluid className="my-4 outer-container">
      <Row className="mb-3">
        <Col>
          <h3 className="text-center">Aided Staff Salary Detail</h3>
          {salaryList.length === 0 && isLoading==true && (
            <Container fluid className="outer-container my-4">
              <Row>
                <Col>
                  <div className="not-found-box">Loading...</div>
                </Col>
              </Row>
            </Container>
          )}
        </Col>
      </Row>

      <Row className="mb-3 justify-content-end">
        <Col md="auto">
          <Link
            // to="/addsalaryaided"
            to={`/addsalaryaided/${user_id}`}
            className="btn-top">
            Add Salary
          </Link>
          <Link to="/userlist" className="btn-top m-2">
            Back
          </Link>
          {/* <Button className="m-2 p-2 btn-top" onClick={() => window.history.back()}>Back</Button> */}
        </Col>
      </Row>

      <div className="customer-table-wrapper">
        <Table bordered responsive className="customer-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              <th>Designation / Dept.</th>
              <th>DOJ</th>
              <th>Basic Salary</th>
              <th>Total Days</th>
              <th>LoP</th>
              <th>Working Days</th>
              <th>Total Deduction</th>
              <th>Net Salary</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {
              salaryList.length > 0 ? (
              salaryList.map((record, index) => (
                <tr key={record.salary_id}>
                  {/* <td>{index + 1}</td> */}
                  <td>{salaryList.length - index}</td>
                  <td>{record.name}</td>
                  <td>{record.desig_name} - {record.depart_name}</td>
                  <td>{record.date_of_join}</td>
                  <td><BiRupee /> {record.basic}</td>
                  <td>{record.total_days}</td>
                  <td>{record.lop}</td>
                  <td>{record.working_days}</td>
                  <td><BiRupee /> {record.deduction}</td>
                  <td><BiRupee /> {record.net_salary}</td>

                  <td className="action-icons">
                    <Link to={`/viewsalaryaided/${record.salary_id}`} className="me-2">
                      <FaEye className="view-icon" />
                    </Link>

                    <Link to={`/editsalaryaided/${record.salary_id}`} className="me-2">
                      <FaEdit className="edit-icon" />
                    </Link>

                    <FaTrash
                      className="delete-icon"
                      onClick={() => handleDelete(record.salary_id)}
                    />
                  </td>
                </tr>
              ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center text-muted">
                    No records found
                  </td>
                </tr>
              )
            }
          </tbody>

        </Table>
      </div>
    </Container>
  );
};

export default SalaryAidedDetail;